/* The persistent buy bar.

   Shows once the hero's own CTA has scrolled away, hides again while the
   closing CTA is on screen, so two buy buttons are never live at once.

   A PLAIN SCROLL LISTENER, NOT IntersectionObserver, on purpose.
   getBoundingClientRect is synchronous and always truthful. IO only delivers
   its callback on a rendering frame, so anywhere frames are throttled the bar
   silently never appears and nothing errors to tell you why. measure() also
   runs once inline, so a page opened already scrolled (an #ev-faq link, a
   browser restoring scroll position) starts in the right state instead of
   waiting for a scroll that may never come.

   The bar ships with the hidden attribute and only ever loses it here. If this
   script fails to load, there is no half-wired bar stuck across the page. */
(function(){
  var bar = document.getElementById('ev-sticky');
  if (!bar) return;
  var heroCta = document.querySelector('.ev-cta');
  var closing = document.querySelector('.ev-close');
  if (!heroCta) return;

  bar.hidden = false;
  var ticking = false;

  function measure(){
    ticking = false;
    var passedHero = heroCta.getBoundingClientRect().bottom < 0;
    // 0.75 rather than 0: hand over to the closing CTA as it arrives, not once
    // it is already centred, otherwise both buttons sit on screen together.
    var closeNear = closing ? closing.getBoundingClientRect().top < innerHeight * 0.75 : false;
    bar.classList.toggle('is-up', passedHero && !closeNear);
  }
  function onScroll(){
    if (ticking) return;
    ticking = true;
    if (window.requestAnimationFrame) requestAnimationFrame(measure);
    else measure();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  measure();

  // Exposed ONLY so the decision can be asserted from the console in
  // environments where scroll events and frames are throttled and the class
  // toggle cannot be observed. Reads state, changes nothing.
  bar.evShouldShow = function(){
    return heroCta.getBoundingClientRect().bottom < 0 &&
      !(closing && closing.getBoundingClientRect().top < innerHeight * 0.75);
  };
})();
